import type { IFlattenedCategory } from "app/common/services/categoryService.types";
import { translate } from "app/filters/i18nFilter";
import { renderIndustryDataAvailabilityNotice } from "app/pages/digital-marketing/ad-intelligence/common/data-availability/IndustryDataAvailabilityBanner";
import { useDurationSubtitleFilter } from "app/pages/digital-marketing/ad-intelligence/common/hooks/useDurationSubtitleFilter";
import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";

import { DisplayAdvertisingDeviceBreakdownWidget } from "../../DisplayAdvertisingDeviceBreakdownWidget";
import { useIndustryDeviceBreakdown } from "./useIndustryDeviceBreakdown";

interface IIndustryDeviceBreakdownProps {
    category: IFlattenedCategory;
}

export const IndustryDeviceBreakdown = ({ category }: IIndustryDeviceBreakdownProps) => {
    const { data, isLoading, isError, availability } = useIndustryDeviceBreakdown(category);
    const durationSubtitleFilter = useDurationSubtitleFilter(data?.startDate);

    const showBreakdownEmptyState = !isLoading && (!data || isError);

    return (
        <WidgetContainer
            title={translate("ad.intelligence.advertiser.overview.breakdown.widget.title")}
            tooltip={translate("ad.intelligence.advertiser.overview.breakdown.widget.title.tooltip")}
            subtitleFilters={[durationSubtitleFilter]}
            height="100%"
            isLoading={isLoading}
            loaderWidth="100%"
            showSubtitleFiltersLoadingState={false}
            loaderHeight={98}
            automationId="industry-device-breakdown-widget"
            noticeSlot={renderIndustryDataAvailabilityNotice(availability)}
        >
            <DisplayAdvertisingDeviceBreakdownWidget
                spendShare={data?.spendShare ?? 0}
                impressionsShare={data?.impressionsShare ?? 0}
                visitsShare={data?.visitsShare ?? 0}
                hasAdIntelMetrics
                showBreakdownEmptyState={showBreakdownEmptyState}
                performanceError={isError}
            />
        </WidgetContainer>
    );
};
